(() => {
  if (customElements.get('sticky-add-to-cart')) return;

  const MOBILE_MQ = '(max-width: 480px)';
  const BUYBOX_SELECTORS = [
    'product-subscription-form-widget',
    '.product-form__buttons',
    '.product_variant_block',
    '.product_buybutton_block',
    'product-form',
  ];
  const SCROLL_SELECTORS = [
    'product-subscription-form-widget',
    '.product-form__buttons',
  ];
  const SCROLL_PADDING = 20;

  class StickyAddToCart extends HTMLElement {
    constructor() {
      super();
      this.onClick = this.onClick.bind(this);
      this.onMediaChange = this.onMediaChange.bind(this);
      this.onSectionLoad = this.onSectionLoad.bind(this);
      this.observer = null;
      this.mediaQuery = window.matchMedia(MOBILE_MQ);
    }

    connectedCallback() {
      this.button = this.querySelector('.js-sticky-add-to-cart-button');
      this.button?.addEventListener('click', this.onClick);
      this.mediaQuery.addEventListener('change', this.onMediaChange);

      if (typeof Shopify !== 'undefined' && Shopify.designMode) {
        document.addEventListener('shopify:section:load', this.onSectionLoad);
      }

      this.setup();
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.onClick);
      this.mediaQuery.removeEventListener('change', this.onMediaChange);
      this.teardownObserver();
      this.setFeatureActive(false);
      this.setVisible(false);

      if (typeof Shopify !== 'undefined' && Shopify.designMode) {
        document.removeEventListener('shopify:section:load', this.onSectionLoad);
      }
    }

    setup() {
      this.teardownObserver();

      if (!this.mediaQuery.matches) {
        this.setFeatureActive(false);
        this.setVisible(false);
        return;
      }

      this.setFeatureActive(true);

      const buybox = this.findElement(BUYBOX_SELECTORS);
      if (!buybox) {
        this.setVisible(false);
        return;
      }

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            this.setVisible(!entry.isIntersecting);
          });
        },
        {
          root: null,
          rootMargin: '-100px 0px 0px 0px',
          threshold: 0,
        }
      );

      this.observer.observe(buybox);
    }

    findElement(selectors) {
      for (const selector of selectors) {
        const element = document.querySelector(selector);
        if (element) return element;
      }
      return null;
    }

    onClick(event) {
      event.preventDefault();
      const target = this.findElement(SCROLL_SELECTORS);
      if (!target) return;

      this.setVisible(false);
      this.scrollFullyIntoView(target);
    }

    scrollFullyIntoView(element) {
      const rect = element.getBoundingClientRect();
      const absoluteTop = window.scrollY + rect.top;
      const absoluteBottom = window.scrollY + rect.bottom;
      const viewportHeight = window.innerHeight;
      let top = absoluteBottom - viewportHeight + SCROLL_PADDING;

      if (rect.height + SCROLL_PADDING * 2 <= viewportHeight && absoluteTop - top < SCROLL_PADDING) {
        top = absoluteTop - SCROLL_PADDING;
      }

      window.scrollTo({
        top: Math.max(0, top),
        behavior: 'smooth',
      });
    }

    setVisible(isVisible) {
      this.classList.toggle('is-hidden', !isVisible);
      this.setAttribute('aria-hidden', String(!isVisible));
      document.documentElement.classList.toggle('sticky-add-to-cart-visible', isVisible);
    }

    setFeatureActive(isActive) {
      document.documentElement.classList.toggle('has-sticky-add-to-cart', isActive);
    }

    teardownObserver() {
      this.observer?.disconnect();
      this.observer = null;
    }

    onMediaChange() {
      this.setup();
    }

    onSectionLoad() {
      this.setup();
    }
  }

  customElements.define('sticky-add-to-cart', StickyAddToCart);
})();
